import { useRef, useState } from "react";
import { Image, Loader2 } from "lucide-react";

interface ImageUploadProps {
  onImageSelect: (imageData: { url: string; base64: string }) => void;
  disabled?: boolean;
}

export function ImageUpload({ onImageSelect, disabled }: ImageUploadProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 验证文件类型
    if (!file.type.startsWith("image/")) {
      alert("请选择图片文件");
      return;
    }

    // 验证文件大小 (最大 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert("图片大小不能超过 10MB");
      return;
    }

    setUploading(true);

    try {
      // 读取为 base64
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64 = event.target?.result as string;
        
        // 回调给父组件
        onImageSelect({
          url: base64,
          base64: base64.split(",")[1], // 移除 data:image/xxx;base64, 前缀
        });
        
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("图片上传失败:", error);
      alert("图片上传失败");
      setUploading(false);
    }

    // 清空 input,允许重复选择同一文件
    e.target.value = "";
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        disabled={disabled || uploading}
        className="hidden"
      />
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled || uploading}
        className="w-9 h-9 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        title="上传图片"
      >
        {uploading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Image className="w-4 h-4" />
        )}
      </button>
    </>
  );
}
